import styled from 'styled-components'
import { Color } from 'root-constants'

type TTitleProps = {
  hasQuestionDescription: boolean
}

export const StyledSimplePage = {
  Title: styled.h1<TTitleProps>`
    margin: ${({ hasQuestionDescription }) =>
      hasQuestionDescription ? '40px 0 24px' : '40px 0'};
    font-weight: 500;
    font-size: 24px;
    line-height: 33px;
    color: ${Color.WHITE};
  `,
  Subtitle: styled.h2`
    margin-bottom: 40px;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: ${Color.WHITE};
  `,
}
